import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { insightsApi } from "@api/enpoints/insights-api";
import { apiErrorMessage } from "@api/enpoints/clients-api";
/** The browser's IANA time zone (e.g. "Europe/Amsterdam"); the API falls back to UTC for an unknown one. */
export const browserTimeZone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    }
    catch (_a) {
        return "UTC";
    }
};
/** Loads the overview (cards 1-3) and the monthly alarms (card 4) independently, so one failure keeps the rest. */
export const useInsightsDashboard = () => {
    const { t } = useTranslation(["common"]);
    const [overview, setOverview] = useState({ data: null, loading: true, error: null });
    const [alarms, setAlarms] = useState({ data: null, loading: true, error: null });
    useEffect(() => {
        let active = true;
        const failed = (error) => apiErrorMessage(error, t("common:catalog.insights.loadFailed", "Could not load the data."));
        insightsApi
            .getOverview()
            .then((r) => {
            var _a;
            if (active)
                setOverview({ data: (_a = r.data) !== null && _a !== void 0 ? _a : null, loading: false, error: null });
        })
            .catch((e) => {
            if (active)
                setOverview({ data: null, loading: false, error: failed(e) });
        });
        insightsApi
            .getMonthlyAlarms(browserTimeZone(), 12)
            .then((r) => {
            var _a;
            if (active)
                setAlarms({ data: (_a = r.data) !== null && _a !== void 0 ? _a : null, loading: false, error: null });
        })
            .catch((e) => {
            if (active)
                setAlarms({ data: null, loading: false, error: failed(e) });
        });
        return () => {
            active = false;
        };
    }, [t]);
    return { overview, alarms };
};
